angular.module('tradersyard').controller('HeadCtrl', [
    '$scope',
    'graph-report-service',
    function ($scope, $service) {
        $scope.stockBar = null;

        window.onscroll = function () {
            $scope.stockBar =
                $scope.stockBar === null ? document.querySelector('.js-marquee-wrapper') : $scope.stockBar;
            if (window.scrollY >= 93) {
                $scope.stockBar.classList.add('stop-animation');
            }
            if (window.scrollY < 93) {
                $scope.stockBar.classList.remove('stop-animation');
            }
        };
    },
]);
